var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "confirmation" }, [
    _c(
      "div",
      {
        staticClass: "confirmation-scroll",
        style: [{ height: _vm.scrollHeight + "px" }],
      },
      [
        _c(
          "div",
          { staticClass: "confirmation-header" },
          [
            _c(
              "picture",
              {
                directives: [
                  {
                    name: "lazyload",
                    rawName: "v-lazyload",
                    value: {
                      src: _vm.selectedHotel.propertyImage,
                      set: [
                        { width: "414", height: "180", breakpoint: "xs" },
                        { width: "810", height: "476", breakpoint: "lg" },
                      ],
                      fit: "crop",
                      align: "center",
                    },
                    expression:
                      "{\n          src: selectedHotel.propertyImage,\n          set: [\n            { width: '414', height: '180', breakpoint: 'xs' },\n            { width: '810', height: '476', breakpoint: 'lg' },\n          ],\n          fit: 'crop',\n          align: 'center',\n        }",
                  },
                ],
                staticClass: "image-wrapper background",
              },
              [
                _c("img", {
                  staticClass: "image",
                  attrs: {
                    src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                    alt:
                      _vm.selectedHotel.propertyImageAlt ||
                      _vm.selectedHotel.propertyName,
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("header-close", { attrs: { deactivate: _vm.deactivate } }),
            _vm._v(" "),
            _c("div", { staticClass: "confirmation-header-info" }, [
              _c("div", { staticClass: "confirmation-header-heading" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.tc("booking.yourStay")) +
                      "\n          "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "confirmation-header-property" }, [
                _c(
                  "div",
                  {
                    staticClass: "confirmation-header-property-name",
                    attrs: {
                      "data-component": "confirmation-header-property-name",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.selectedHotel.propertyName) +
                        "\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "confirmation-header-property-country" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.selectedHotel.country) +
                        "\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.propertyHasChat || _vm.propertyHasPhone
                  ? _c(
                      "div",
                      { staticClass: "confirmation-header-property-info" },
                      [
                        _vm.propertyHasPhone
                          ? _c("a", {
                              staticClass: "phone-icon",
                              attrs: { href: "tel:" + _vm.selectedHotel.phone },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.propertyHasChat
                          ? _c("a", {
                              staticClass: "chat-icon",
                              attrs: {
                                href: _vm.selectedHotel.liveChat,
                                target: "_blank",
                              },
                            })
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showEditStayCta
                  ? _c(
                      "a",
                      {
                        staticClass: "edit",
                        attrs: {
                          href: "#",
                          "aria-label":
                            _vm.tc("booking.edit") +
                            " " +
                            _vm.tc("booking.yourStay"),
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.$emit("change-page", "hotel-list")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.tc("booking.edit")) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              false
                ? _c("div", { staticClass: "confirmation-header-utility" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "icon notification" }),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "confirmation-alert" },
          [
            _vm.showAlert
              ? _c("alert", {
                  attrs: {
                    "show-alert": _vm.selectedHotel.alertEnabled,
                    "has-close-icon": _vm.selectedHotel.alertHasCloseIcon,
                    "text-color": _vm.selectedHotel.alertTextColor,
                    "background-color": _vm.selectedHotel.alertBackgroundColor,
                    "alert-label": _vm.selectedHotel.alertLabel,
                    "alert-label-button": _vm.selectedHotel.alertLabelButton,
                  },
                  on: { "open-hotel-alerts": _vm.openHotelAlerts },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "confirmation-content" }, [
          _c(
            "div",
            {
              staticClass: "confirmation-booking-dates",
              attrs: { "data-component": "confirmation-booking-dates" },
            },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.tc("booking.date")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "edit button--text underline size-md black",
                    attrs: {
                      href: "#",
                      "aria-label":
                        _vm.tc("booking.edit") + " " + _vm.tc("booking.date"),
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("change-page", "calendar")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.tc("booking.edit")) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "confirmation-booking-date" }, [
                _c("div", {
                  staticClass: "confirmation-booking-date-start",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.dateFilter(_vm.localQuery.stayDateStart)
                    ),
                  },
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "confirmation-booking-date-end",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.dateFilter(_vm.localQuery.stayDateEnd)
                    ),
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "confirmation-booking-date-nights" }, [
                  _c("span", [_vm._v(_vm._s(_vm.localRangeInDays))]),
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.localRangeInDays > 1
                          ? _vm.tc("noums.nightPlural")
                          : _vm.tc("noums.nightSingular")
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "confirmation-room",
              attrs: { "data-component": "confirmation-room" },
            },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.tc("booking.guestsAndRooms")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "edit button--text underline size-md black",
                    attrs: {
                      href: "#",
                      "aria-label":
                        _vm.tc("booking.edit") +
                        " " +
                        _vm.tc("booking.guestsAndRooms"),
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("change-page", "guests-and-rooms")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.tc("booking.edit")) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "confirmation-room-details" }, [
                _c("span", { staticClass: "people" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getSummaryDetails({
                        capitalized: true,
                        customQuery: _vm.localQuery,
                      })
                    )
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.showSpecialCodeSection
            ? _c(
                "div",
                {
                  staticClass: "confirmation-code",
                  attrs: { "data-component": "confirmation-code" },
                },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.tc("booking.specialCode")) +
                          "\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.specialCodesOpened && !_vm.havePromoValues,
                          expression: "!specialCodesOpened && !havePromoValues",
                        },
                      ],
                      staticClass: "confirmation-code-add",
                      on: {
                        click: function ($event) {
                          _vm.specialCodesOpened = true
                        },
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.specialCodesOpened = true
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "icon-plus" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "code-text" }, [
                        _vm._v(
                          _vm._s(_vm.tc("booking.add")) +
                            " " +
                            _vm._s(_vm.tc("booking.specialCode"))
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.specialCodesOpened || _vm.havePromoValues,
                          expression: "specialCodesOpened || havePromoValues",
                        },
                      ],
                      staticClass: "mohg-form code-form",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      !_vm.isBookingEditMode
                        ? _c("div", { staticClass: "input" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.iataNumber,
                                  expression: "iataNumber",
                                },
                              ],
                              class: [{ "have-value": !!_vm.iataNumber }],
                              attrs: {
                                id: "iataNumber",
                                tabindex: "0",
                                type: "text",
                                name: "iataNumber",
                              },
                              domProps: { value: _vm.iataNumber },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.iataNumber = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "floating",
                                attrs: { for: "iataNumber" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.tc("formFields.iataNumber")) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.promotionCode,
                              expression: "promotionCode",
                            },
                          ],
                          class: [
                            {
                              "have-value": !!_vm.promotionCode,
                              "input-validation-error": _vm.employeePromosError,
                            },
                          ],
                          attrs: {
                            id: "promotionCode",
                            tabindex: "0",
                            type: "text",
                            name: "promotionCode",
                          },
                          domProps: { value: _vm.promotionCode },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.promotionCode = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "floating",
                            attrs: { for: "promotionCode" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.tc("formFields.promoCode")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.employeePromosError
                          ? _c(
                              "span",
                              {
                                staticClass: "field-validation-error",
                                attrs: {
                                  "data-valmsg-for": "promotionCode",
                                  "data-valmsg-replace": "true",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.tc("errors.promoCodeOnlyLoggedUser")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.groupCode,
                              expression: "groupCode",
                            },
                          ],
                          class: [{ "have-value": !!_vm.groupCode }],
                          attrs: {
                            id: "groupCode",
                            tabindex: "0",
                            type: "text",
                            name: "groupCode",
                          },
                          domProps: { value: _vm.groupCode },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.groupCode = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "floating",
                            attrs: { for: "groupCode" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.tc("formFields.groupCode")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showSignInSection
            ? _c(
                "div",
                {
                  staticClass: "confirmation-signin",
                  attrs: { "data-component": "confirmation-signin" },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.openAuth("login")
                        },
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.openAuth("login")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.tc("auth.signIn")))]
                  ),
                  _vm._v(
                    "\n        " + _vm._s(_vm.tc("booking.or")) + "\n        "
                  ),
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.openAuth("registration")
                        },
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.openAuth("registration")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.tc("auth.join")))]
                  ),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.tc("booking.signInDetails")) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "footer",
        staticClass: "confirmation-footer",
        attrs: { "data-component": "confirmation-footer" },
      },
      [
        _c(
          "div",
          { staticClass: "confirmation-best-rate" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.tc("booking.ourBestRate")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "v-dropdown",
              {
                staticClass: "tooltip tooltip-variant--booking",
                attrs: {
                  distance: 24,
                  skidding: 120,
                  "popper-class": "booking-confirmation",
                },
                scopedSlots: _vm._u([
                  {
                    key: "popper",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "tooltip-variant--booking-content" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.tc("booking.bestPriceWarranty")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("button", {
                  staticClass: "info-black",
                  attrs: {
                    role: "presentation",
                    "aria-label": _vm.tc("booking.bestPriceWarranty"),
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _vm._m(1),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "confirmation-cta" }, [
          _c(
            "button",
            { class: [{ loading: _vm.isLoading }], on: { click: _vm.submit } },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.tc("booking.roomsAndPackages")) +
                  "\n        "
              ),
              _c("div", { staticClass: "sr-only", attrs: { role: "status" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.isLoading
                        ? _vm.tc("accessibility.loadingButtonStatus")
                        : ""
                    ) +
                    "\n        "
                ),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "confirmation-header-utility-left" }, [
      _c("div", { staticClass: "icon info" }),
      _vm._v(" "),
      _c("div", { staticClass: "icon phone" }),
      _vm._v(" "),
      _c("div", { staticClass: "icon chat" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "close-btn" }, [
      _c("span", { staticClass: "close" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }